import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { languageswitchConstants } from '../constants';
import { SocialMediaListRender } from './SocialMediaListRender';


export const SocialMediaListHI = () => {
    const dispatch = useDispatch();
    const s = useSelector(state => state.socialmediaHI.socialmediaListHI);
    const [socialmediaListHI, setSocialmedialListHI] = useState(s);
    const loading = useSelector(state => state.socialmediaHI.loading);
    const e = useSelector(state => state.socialmediaHI.error);
    const [error, setError] = useState(e);
    const d = useSelector(state => state.socialmediaHI.done);
    const [done, setDone] = useState(d);
    var dataLimitPerPage = 15;

    const lang = useSelector(state => state.languageswitch);
    if (lang === languageswitchConstants.HINDI_NR) {
        return <SocialMediaListRender
            stateList={s}
            socialmediaList={socialmediaListHI}
            setSocialmedialList={setSocialmedialListHI}
            loading={loading}
            errorState={e}
            error={error}
            setError={setError}
            doneState={d}
            done={done}
            setDone={setDone}
            dataLimitPerPage={dataLimitPerPage}
        />
    }
}